import { gql } from "@apollo/client";

const SUBSCRIPTION_RESPONSE = `employee_user_id
      dealership_id
      employee_details {
        employee {
          role
          employee_user_id
          last_name
          first_name
          email
          mobile_number
          previous_target
          assigned_target
          completed
          status
          percentage
          quotes_requested
          requested_percentage
          notification_preference
          verification_preference
          appointment_preference
          review_preference
          referral_preference
          knowledge_hub_preference
          csi_preference
          prequal_preference
          id_verification_preference
          app_download_preference
          premiums_verified
          premiums_req_quote
          premiums_captured
          customers_captured
          lines_written
          verification_workflow_id
          is_active
          review_provided 
          referral_provided 
          appointment_set 
          apps_downloaded 
          satisfied_yes 
          satisfied_no 
          employee_code
          watched_artifacts
        }
        errors {
          code
          type
          message
        }
      }
      insurance_details {
        total
        errors {
          type
          code
          message
        }
        customers {
        isAppsDownloaded
         surveyResponse {
         question
         answer
        }
        videoResponse {
          title
          watched_secs
          total_secs
          last_watched_secs
        }
        reviewResponse {
          answer
          message
          review_question
          isReview
        }
          vehicleTransactionResponse {
  vehicle_type
  transaction_type
  year
  make
  model
}
        referralResponse {
          name
          mobile_number
          referral_question
        }
        appointmentResponse {
          preference
          time
          date
        }
          dealership {
            city
            street
            zipcode
            number
            state
          }
          agentDetail {
            full_name
            full_address
            agency_name
            email
            phone_number
          }
          customer {
            date
            user_id
            last_name
            first_name
            mfa_preference
            carrier_password
            carrier_userid
            insurance_carrier
            third_field
            watched_artifacts
          }
          contact {
            address
            email
            mobile_number
          }
          employee {
            employee_user_id
            employee_lastname
            employee_firstname
            mobile_number
            email
          }
          vehicles {
            year
            make
            model
            vehicle_status_id
            vin
          }
          insuranceList {
            policy {
              policy_number
              policy_begin
              policy_end
              collision_deductible
              comp_deductible
              carrier_name
              is_cancelled
              total_premium
              is_issue
              created_at
              
            }
            documents {
              document_name
              document_url
            }
          }
          requestQuote {
            customerStatus
            customerStatusId
            linesWritten
          }
          questionnaire {
            question
            options
          }
        }
      }     
      errors {
        code
        type
        message
      }
      vehicle_id
      user_id`;

export const LOGIN = gql`
  mutation Mutation($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      user_id
      dealership_id
      role
      first_name
      middle_name
      brand_name
      last_name
      token
      dealership_logo
      dealership_name
      dealership_code
      payload
      is_mfa
      errors {
        code
        type
        message
      }
      associateDetails {
        dealership_id
        dealership_user_id
        dealership_name
        dealership_code
        payload_preference
        brand_name
        is_active
        dealership_logo
        verification_workflow_id
        percentage
        logout_time
        # walkthrough_video{
        #     video_url
        #   es_video_url
        #   text
        #   es_text
        # }
      }
    }
  }
`;

export const CONSENT_CONNECT = gql`
  mutation Mutation($insuranceInput: InsuranceInput!) {
    consentAndConnect(insuranceInput: $insuranceInput) {
      pull_id
      pull_jwt
      errors {
        code
        type
        message
      }
    }
  }
`;

export const FINALIZE_CANOPY_VERIFICATION = gql`
  mutation Mutation($finalizeInput: FinalizeCanopyInput!) {
    finalizeCanopyVerification(finalizeInput: $finalizeInput) {
      pull_id
      pull_jwt
      errors {
        code
        type
        message
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation Mutation($createUserInput: CreateUserInput!) {
    createUser(createUserInput: $createUserInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;

export const FETCH_LOG = gql`
  mutation Mutation($userId: Int!) {
    fetchApiLog(userId: $userId) {
      payload {
        output_payload
        created_at
      }
      errors {
        code
        type
        message
      }
    }
  }
`;

export const SEND_EMAIL = gql`
  mutation Mutation($verificationRequestInput: VerificationRequestInput!) {
    sendEmailRequest(verificationRequestInput: $verificationRequestInput) {
      user_id
    }
  }
`;

export const SEND_TEXT = gql`
  mutation Mutation($verificationRequestInput: VerificationRequestInput!) {
    sendTextRequest(verificationRequestInput: $verificationRequestInput) {
      user_id
    }
  }
`;

export const SELECT_MFA_OPTIONS = gql`
  mutation Mutation($mfaInput: MfaInput!) {
    selectMfaOption(mfaInput: $mfaInput) {
      pull_id
      pull_jwt
      errors {
        code
        type
        message
      }
    }
  }
`;

export const SUBMIT_MFA_OPTIONS = gql`
  mutation Mutation($mfaInput: MfaInput!) {
    submitMfaOption(mfaInput: $mfaInput) {
      pull_id
      pull_jwt
      errors {
        code
        type
        message
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation Mutation($createUserInput: CreateUserInput!) {
    updateUser(createUserInput: $createUserInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;

export const SUBMIT_VEHICLE_TRADE = gql`
  mutation Mutation($tradeInput: TradeInput!) {
    submitTradeVehicle(tradeInput: $tradeInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;

export const REQUEST_QUOTE = gql`
  mutation Mutation($requestInput: RequestInput!) {
    requestQuote(requestInput: $requestInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;
export const CREATE_CUSTOMER = gql`
  mutation Mutation($customerInput: CustomerInput) {
    createCustomer(customerInput: $customerInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;

export const REQUEST_PASSWORD = gql`
  mutation Mutation($passwordInput: PasswordInput!) {
    requestPassword(passwordInput: $passwordInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation Mutation($passwordInput: PasswordInput!) {
    updatePassword(passwordInput: $passwordInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;
export const UPDATE_LINES_WRITTEN = gql`
  mutation Mutation($linesInput: LinesInput!) {
    updateLinesWritten(linesInput: $linesInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;
export const UPDATE_CUSTOMER_STATUS = gql`
  mutation Mutation($statusInput: StatusInput!) {
    updateCustomerStatus(statusInput: $statusInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;
export const MANAGE_DEALERSHIP = gql`
  mutation Mutation($dealershipInput: DealershipInput!) {
    manageDealership(dealershipInput: $dealershipInput) {
      dealership_id
      full_name
      brand_name
      is_active
      logo_url
      number
      street
      state
      zipcode
      city
      email
      phone_number
      percentage
      logout_time
      referral_notification_id
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation Mutation($subscriptionInput: SubscriptionInput!) {
    updateSubscription(subscriptionInput: $subscriptionInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const IMPORT_USERS = gql`
  mutation Mutation($importInput: ImportInput) {
    importUsers(importInput: $importInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const EMAIL_BILL_INPUT = gql`
  mutation Mutation($emailBillInput: EmailBillInput!) {
    sendEmailBill(emailBillInput: $emailBillInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const TRANSACTION_HISTORY = gql`
  mutation Mutation($transactionInput: TransactionInput!) {
    fetchTransactions(transactionInput: $transactionInput) {
      transaction {
        timestamp
        status {
          consent
          carriers
          login
          webhook
          pull
        }
        output_payload
        created_at
        is_issue
        employeeName
        dealershipName
        customer {
          fullName
          email
          contactNumber
          vin
          address
        }
        pull {
          pullId
          carrier
          policies
          documents
        }
      }
      date
      total
    }
  }
`;
export const MANAGE_ASSOCIATION = gql`
  mutation Mutation($associateInput: AssociateInput!) {
    manageAssociation(associateInput: $associateInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;

export const MANAGE_USER = gql`
  mutation Mutation($createUserInput: CreateUserInput!) {
    manageUser(createUserInput: $createUserInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
`;

export const LOGIN_MFA_OPTIONS = gql`
  mutation Mutation($loginMfaInput: LoginMfaInput!) {
    loginMfaOptions(loginMfaInput: $loginMfaInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const VALIDATE_MFA_LOGIN = gql`
  mutation Mutation($validateInput: ValidateInput!) {
    validateMfaLogin(validateInput: $validateInput) {
      user_id
      dealership_id
      role
      first_name
      middle_name
      last_name
      brand_name 
      token
      dealership_logo
      dealership_name
      dealership_code
      payload
      is_mfa
      dealershipServices {
        service_id
      }
      errors {
        code
        type
        message
      }
      associateDetails {
        dealership_id
        dealership_user_id
        dealership_name
        brand_name 
        dealership_code
        payload_preference
        is_active
        dealership_logo
        verification_workflow_id
        percentage
        logout_time
        crm_user_status
        walkthrough_video {
          video_url
          es_video_url
          text
          es_text
          knowledgehub_video_url
          es_knowledgehub_video_url
          knowledgehub_text
          es_knowledgehub_text
        }
        dealershipServices {
          service_id
        }
      }
    }
  }
`;

export const FETCH_INSURANCE_TRIGGER = gql`
  mutation Mutation($requestInput: RequestInput) {
    fetchInsuranceTrigger(requestInput: $requestInput) {
      ${SUBSCRIPTION_RESPONSE}
    }
  }
  `;

export const EMAIL_OPT_OUT = gql`
  mutation Mutation($optOutInput: OptOutInput!) {
    manageEmailOptout(optOutInput: $optOutInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const MANAGE_CRM_USERS = gql`
  mutation Mutation($crmInput: CrmInput) {
    manageCrmUsers(crmInput: $crmInput) {
      crm_user_status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const MANAGE_ARTIFACTS = gql`
  mutation Mutation($artifactsInput: ArtifactsInput) {
    manageArtifacts(artifactsInput: $artifactsInput) {
      dealership_id
      text {
        id
        text
        es_text
        position
      }
      survey {
        id
        question
        es_question
        es_options
        options
        position
      }
      video {
        id
        title
        es_title
        url
        es_url
        position
      }
      review {
        id
        message
        es_message
        google
        facebook
        dealer_rater
        position
        referral_question
        es_referral_question
        review_question
        second_review_question
        es_review_question
        es_second_review_question
      }
      dealer_app {
        id
        message
        es_message
        playstore
        appstore
        position
      }
      appointment {
        id
        position
        message
        es_message
        preference_options
        es_preference_options
      }
      tradeArtifact {
        id
        text
        es_text
      }
      quoteArtifact {
        id
        text
        es_text
        quote_options
        es_quote_options
        quote_question
        es_quote_question
      }
      vehicleTransactionArtifact {
        id
        vehicle_information
        es_vehicle_information
        vehicle_message
        es_vehicle_message
        vehicle_options
        es_vehicle_options
        transaction_message
        es_transaction_message
        transaction_options
        es_transaction_options
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      warrantyArtifact {
        id
        warranty_message
        warranty_es_message
        is_enabled
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      ServiceMaintenanceArtifact {
        id
        followup_message_1
        es_followup_message_1
        followup_message_2
        es_followup_message_2
        followup_message_3
        es_followup_message_3
        ai_url {
          english_url
          spanish_url
        }
      }
      walkthroughVideo {
        id
        video_url
        es_video_url
        text
        es_text
        knowledgehub_video_url
        es_knowledgehub_video_url
        knowledgehub_text
        es_knowledgehub_text
      }
      service {
        id
        service_id
        service_text
        es_service_text
        ai_url {
          english_url
          spanish_url
        }
      }
      displayRules {
        id
        artifact_type_id
        artifact_id
        vehicle_rules
        transaction_rules
      }
      surveyOther {
        id
        text
        # es_text
        avatar_id
        voice_id
        url
        language_id
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const MANAGE_ARTIFACTS_RESPONSE = gql`
  mutation Mutation($responseInput: ResponseInput) {
    manageArtifactResponse(responseInput: $responseInput) {
      id
      errors {
        type
        code
        message
      }
    }
  }
`;
export const UPDATE_SALES_AIDS = gql`
  mutation Mutation($salesAidsInput: SalesAidsInput) {
    updateSalesAids(salesAidsInput: $salesAidsInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const GET_VIDEO_UPLOAD_URL = gql`
  mutation GetVideoUploadUrl {
    getVideoUploadUrl {
      status
      message
      uploadUrl
      publicUrl
      errors {
        type
        code
        message
      }
    }
  }
`;

export const UPLOAD_VIDEO = gql`
  mutation UploadVideo($videoUploadInput: VideoUploadInput!) {
    uploadVideo(videoUploadInput: $videoUploadInput) {
      status
      message
      publicUrl
      errors {
        type
        code
        message
      }
    }
  }
`;

export const UPDATE_ARTIFACT_LOG_LANGUAGE = gql`
  mutation UpdateArtifactLogLanguage(
    $updateArtifactLogLanguageInput: UpdateArtifactLogLanguageInput!
  ) {
    updateArtifactLogLanguage(
      updateArtifactLogLanguageInput: $updateArtifactLogLanguageInput
    ) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;
export const FETCH_VEHICLE_TRANSACTION = gql`
  mutation FetchVehicleTransaction(
    $fetchVehicleTransactionInput: FetchVehicleTransactionInput!
  ) {
    fetchVehicle(fetchVehicleTransactionInput: $fetchVehicleTransactionInput) {
      status
      vehicleTransactionResponse {
        id
        vehicle_id
      }
      errors {
        code
        type
        message
      }
    }
  }
`;

export const CSI_ALERT = gql`
  mutation Mutation($alertInput: AlertInput) {
    csiAlert(alertInput: $alertInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const DEALER_APP_LINK = gql`
  mutation Mutation($linkInput: LinkInput) {
    sendAppLink(linkInput: $linkInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const SUBMIT_REFERRAL = gql`
  mutation Mutation($referralInput: ReferralInput) {
    submitReferralLink(referralInput: $referralInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;
export const SUBMIT_SERVICE_FOLLOWUP = gql`
  mutation SubmitServiceFollowup($serviceFollowupInput: ServiceFollowupInput!) {
    submitServiceFollowup(serviceFollowupInput: $serviceFollowupInput) {
      status
      alreadyBooked
      message
      errors {
        type
        code
        message
      }
    }
  }
`;
export const SUBMIT_SERVICE = gql`
  mutation Mutation($serviceInput: ServiceInput) {
    submitServiceLink(serviceInput: $serviceInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const SUBMIT_CSI = gql`
  mutation Mutation($csiInput: CsiInput) {
    submitCsiLink(csiInput: $csiInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;
export const RESEND_MFA_OPTIONS = gql`
  mutation Mutation($resendMfaInput: ResendMfaInput) {
    resendMfaOption(resendMfaInput: $resendMfaInput) {
      pull_id
      pull_jwt
      errors {
        type
        code
        message
      }
    }
  }
`;

export const DEALERSHIP_AVATAR = gql`
  mutation Mutation($avatarInput: AvatarInput) {
    dealershipAvatar(avatarInput: $avatarInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const VIDEO_GENERATE = gql`
  mutation Mutation($videoInput: VideoInput) {
    videoGenerate(videoInput: $videoInput) {
      video_url
      errors {
        type
        code
        message
      }
    }
  }
`;

const OMNI_DEALERSHIP_SERVICES = `
  service_id
  service_text
  es_service_text
  ai_url {
    english_url
    spanish_url
  }
`;

const OMNI_FETCH_ARTIFACT = `
  dealership_id
  isArtifact
  is_warranty
  has_warranty_coverages
`;
export const OMNI_LOGIN_SERVICE = gql`
  mutation Mutation($omniLoginInput: OmniLoginInput) {
    omniLoginService(omniLoginInput: $omniLoginInput) {
      dealership_id
      dealership_name
      dealership_logo
      first_name
      last_name
      user_id
      verification_workflow_id
      email
      mobile_number
      services {
        # service
        service_id
        service_text
        es_service_text
        ai_url {
          english_url
          spanish_url
        }
      }
      fetchArtifact {
        dealership_id
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const SEND_EMAIL_ARTIFACT = gql`
  mutation Mutation($verificationRequestInput: VerificationRequestInput) {
    sendEmailArtifact(verificationRequestInput: $verificationRequestInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const SEND_TEXT_ARTIFACT = gql`
  mutation Mutation($verificationRequestInput: VerificationRequestInput) {
    sendTextArtifact(verificationRequestInput: $verificationRequestInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const ADMIN_WARRANTY = gql`
  mutation AdminWarranty($warrantySaveInput: WarrantySaveInput) {
    adminWarranty(warrantySaveInput: $warrantySaveInput) {
      status
      dealership_id
      is_warranty
      has_warranty_coverages
      warrantyCoverages {
        id
        warranty_vehicle_type_id
        warranty_classification_id
        warranty_type_en
        warranty_type_es
        coverage_months
        coverage_miles
        info_title_en
        is_enabled
        info_title_es
        info_subtitle_en
        info_subtitle_es
        info_footer_en
        info_footer_es
        information_items {
          id
          coverage_category_en
          coverage_category_es
          coverage_items_en
          coverage_items_es
        }
      }
      warrantyExclusions {
        id
        warranty_vehicle_type_id
        uncoverage_type
        exclusion_category_en
        exclusion_category_es
        exclusion_items_en
        exclusion_items_es
        title_en
        title_es
        footer_en
        footer_es
        columns {
          id
          column_header_en
          column_header_es
          column_items_en
          column_items_es
          sort_order
        }
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const UPDATE_WARRANTY_SWITCH = gql`
  mutation Mutation($warrantySwitchInput: WarrantySwitchInput) {
    updateWarrantySwitch(warrantySwitchInput: $warrantySwitchInput) {
      status
      errors {
        type
        code
        message
      }
    }
  }
`;

export const MANAGE_WARRANTY_RESPONSE = gql`
  mutation ManageWarrantyResponse(
    $warrantyResponseInput: WarrantyResponseInput
  ) {
    manageWarrantyResponse(warrantyResponseInput: $warrantyResponseInput) {
      id
      errors {
        type
        code
        message
      }
    }
  }
`;
export const LOG_KNOWLEDGEHUB_OPEN = gql`
  mutation LogKnowledgeHubOpen($input: LogKnowledgeHubOpenInput!) {
    logKnowledgeHubOpen(input: $input) {
      id
      channel
      created_at
    }
  }
`;
export const FOLLOWUP_REVIEW_CLICK = gql`
  mutation FollowupReviewClick($followupReviewInput: FollowupReviewClickInput!) {
    followupReviewClick(followupReviewInput: $followupReviewInput) {
      status
      url
      errors {
        message
      }
    }
  }
`;
